export const environment = {
  AUTH_MODE: 'footballer',
  GOOGLE_LOGIN_ENABLED: true,
  production: true,
  API_BASE_URL: 'https://next.footballer.zone/api/v0',
  AUTH0_CLIENT_ID: 'tB8ObxF3n30ad48ba0LxfCMeWT4OwwYE',
  AUTH0_AUDIENCE: 'https://app.footballer.zone/api/v0',
  WEB_SOCKET_URL: 'wss://next.footballer.zone/api/v0',
  HOME_BASE_URL: 'https://next.footballer.zone/',
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
  APP_INITIALIZED: 'mobAppInitialized',
  KEY: 'appPublicKey',
  PUSH_ACCESS_TOKEN: 'pushAccessToken',
  OFF_LINE: 'offLine',
  INIT_CODE_REQUESTED: 'initCodeRequested',
  DEBUG: 'debug',
  PROFILE: 'player',
  apiKey: 'AIzaSyDJP8-QD1RsdfR2dF0iVC3KmCu3T4o6eiM',
  GOOGLE_MAPS_MAP_ID: 'f875936a79ad96764b06665b',
  ipInfoApiUrl: 'https://ipinfo.io/geo?token=45b42d45cff351',
  DEFAULT_AVATAR_URL: 'assets/images/player-icon-002.png'
};

export const auth0LockConfig = {
  clientID: 'urisNHb4VRTH0W0xjsdcvWQvXpBdZT9d',
  domain: 'mangonel.eu.auth0.com',
  primaryWidgetColor: '#C0C0C0',
  appTitle: 'Footballer',
  appLogo: '../../assets/images/soccer-icon-1.png'
};
